import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    lists: [],
    list: {},
    message: '',
    type: '',
    code: ''


}
const mutations = {
    SET_DATAS(state, lists) {
        state.lists = lists.reporting_tag_list
    },
    STATUS_DETAILS(state, data) {
        state.message = data.data.status;
        state.type = data.data.type;
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    REPORT_TAG_DETAILS(state, data) {
        state.list = data.reporting_details
    }

}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        sort,
        label
    }) {

        return AppService.reportingtag.getReportingTags(sort, label, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                    rootState.permission.reporting_tags = response.data.data.reporting_tag_list
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createReportingTag({
        commit,
        rootState
    }, data) {

        return AppService.reportingtag.postreporttag(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit("STATUS_DETAILS", response);
                    commit('STATUS_CODE', response.status)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateReportingTag({
        commit,
        rootState
    }, {
        id,
        data
    }) {
        return AppService.reportingtag.postupdatereporttag(id, data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchTagDetails({
            commit,
            rootState
        },
        id
    ) {
        return AppService.reportingtag.getreporttag(id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                commit('REPORT_TAG_DETAILS', response.data.data)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    changeStatus({
            commit,
            rootState
        },
        data
    ) {
        return AppService.reportingtag.tagstatuschange(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deletetag({
            commit,
            rootState
        },
        data
    ) {
        return AppService.reportingtag.deletetag(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    removeOption({
            commit,
            rootState
        },
        data
    ) {
        return AppService.reportingtag.tagoptionremove(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },


}
export default {
    namespaced,
    state,
    mutations,
    actions
}